import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Supabase project "gridroof" (Central EU / Frankfurt) — ref ijojqubvdrdjrmvbknlb.
const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const OFFLINE_ONLY = import.meta.env.VITE_OFFLINE_ONLY === "true";

// When offline-only, or if env is missing, we never construct a client.
export const supabase: SupabaseClient | null =
  OFFLINE_ONLY || !url || !anon ? null : createClient(url, anon);

export const SUPABASE_ENABLED = supabase !== null;
